const adjustHeight = (thumbanilUrl: string, height: number): string => {
  const url = new URL(thumbanilUrl);
  url.searchParams.set('height', height.toString());

  return url.toString();
};

export default adjustHeight;
